import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCommon } from '@shared/apis/common';
import { Buffer } from 'buffer';

@Injectable({
  providedIn: 'root'
})
export class MasterApi extends ApiCommon {

  getConstant(code: any): Observable<any> {
    return this.apiServer.master.getConstant(code);
  }

  getCommonConstantList(codes: any): Observable<any> {
    return this.apiServer.master.getCommonConstantList(codes);
  }

  getStatus(detailType): Observable<any> {
    return this.apiServer.master.getStatus(detailType);
  }

  getStatusForFilter(detailType): Observable<any> {
    return this.apiServer.master.getStatusForFilter(detailType);
  }

  getProductCategories(): Observable<any> {
    return this.apiServer.master.getProductCategories();
  }

  serverFileUpload(formData): Observable<any> {
    return this.apiServer.master.serverFileUpload(formData);
  }

  serverFileDelete(params): Observable<any> {
    return this.apiServer.master.serverFileDelete(params);
  }

  imageUrl(key, ticketNo, secret) {
    const secretKey = Buffer.from(`${ ticketNo }:${ secret }`).toString('base64');
    return this.apiServer.master.imageUrl(key, secretKey);
  }

  tsvCellsUpload(data: any, code?, queryString?: any, isSync?): Observable<any> {
    return this.apiServer.master.tsvCellsUpload(data, code, queryString, isSync);
  }
}
